import {
  Component,
  computed,
  effect,
  inject,
  Inject,
  Injector,
  signal,
  ViewChild,
  WritableSignal,
} from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { Capacitor } from "@capacitor/core";

import { dialogDataType } from "@bitwarden/web-vault/app/models/types/account.types";
import { ConfirmationDialogService } from "@bitwarden/web-vault/app/services/confirmation/confirmation.service";
import { NotificationEnum } from "@bitwarden/web-vault/app/models/enum/notification.enum";
import { AccountView } from "@bitwarden/web-vault/app/models/view/account/account.view";
import { editTransactionTab } from "@bitwarden/web-vault/app/gloss/manage/manage-accounts/edit-transaction-details/edit-transaction-details.component";
import { AddEditTransactionFormComponent } from "@bitwarden/web-vault/app/components/add-edit-transaction-form/add-edit-transaction-form.component";
import { TransactionDataHelper } from "@bitwarden/web-vault/app/shared/utils/helper.transactions/transaction-data-helper";

@Component({
  selector: "app-transaction",
  templateUrl: "./transaction.component.html",
})
export class TransactionComponent {
  private notifyService: ConfirmationDialogService = inject(ConfirmationDialogService);
  private transactionDataHelper: TransactionDataHelper;

  protected selectedAccount: AccountView;
  protected tabActive: WritableSignal<string> = signal(editTransactionTab.transactionDetails);
  protected readonly tabs = Object.values(editTransactionTab);
  protected readonly activeTabIndex = computed(() => this.tabs.indexOf(this.tabActive()));
  protected readonly editTransactionTab = editTransactionTab;

  loading = false;
  /** True while the transaction is being saved; the panel won't close on click-away/Escape. */
  protected submitting = false;
  isSymbolAndCurrencyEqual: boolean = false;

  /** True when running inside the native (iOS/Android) Capacitor shell — gates the camera action. */
  protected readonly isNative = Capacitor.isNativePlatform();

  @ViewChild(AddEditTransactionFormComponent)
  addEditTransactionFormComponent!: AddEditTransactionFormComponent;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: dialogDataType,
    public injector: Injector,
  ) {
    this.selectedAccount = data.accountView;
    this.transactionDataHelper = new TransactionDataHelper(this.injector);
  }

  onSymbolAndCurrencyEqualChange(isEqual: boolean) {
    this.isSymbolAndCurrencyEqual = isEqual;
  }

  submit() {
    const result = this.addEditTransactionFormComponent.completeForm();
    if (result && result !== "touched") {
      this.submitting = true;
      this.transactionDataHelper
        .receivedTransactionData(result, true)
        .then((r) => {
          this.receivedSuccessfulSubmit();
        })
        .finally(() => (this.submitting = false));
    } else {
      this.tabActive.set(editTransactionTab.transactionDetails);
    }
  }

  // --- Document linking actions (UI only — wiring lands after the restyle). ---

  /** Action 1: link a (new) document to the transaction. */
  linkDocument() {
    // TODO: wire to upload + link
  }

  /** Action 2 (mobile only): capture a photo and link it. */
  takePhoto() {
    // TODO: wire to camera capture
  }

  /** Action 3: choose an existing cabinet file to link. */
  linkFromCabinet() {
    // TODO: wire to cabinet picker
  }

  receivedSuccessfulSubmit() {
    this.addEditTransactionFormComponent.resetValue();
    this.data.actionSucceeded();
    this.notifyService.notify(NotificationEnum.success, "success", "transactionAddedSuccessfully");
    this.data.closeDialog();
  }
}
